export class AddBannedDomainDto {
    name!: string;

    constructor(name: string) {
        this.name = name;
    }
}